export const INTERNET_ERROR_MESSAGE = 'Internet error. Could not connect to the database or load data from the internet. Check your internet connection and try again.';

const listeners = new Set();

export function subscribeInternetError(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

function notify(active) {
  listeners.forEach((listener) => {
    try { listener(active); } catch (_) { /* a banner must not break the request */ }
  });
}

export function isBrowserNetworkError(err) {
  if (!err) return false;
  if (err.name === 'AbortError') return false;
  if (typeof navigator !== 'undefined' && navigator.onLine === false) return true;
  const msg = String(err.message || err);
  return /failed to fetch|networkerror|network request failed|load failed|net::err_|enotfound|econnrefused|etimedout|ehostunreach|enetunreach|econnreset|getaddrinfo|internet error/i.test(msg);
}

function requestUrl(input) {
  if (typeof input === 'string') return input;
  if (typeof URL !== 'undefined' && input instanceof URL) return input.href;
  if (input && typeof input.url === 'string') return input.url;
  return '';
}

function isBackendApiUrl(url) {
  return /:5000\b|\/api\/|backend\.fastgrader\.org/i.test(String(url || ''));
}

export function installInternetErrorReporting() {
  if (typeof window === 'undefined' || window.__internetErrorReporting) return;
  window.__internetErrorReporting = true;

  window.addEventListener('offline', () => notify(true));
  window.addEventListener('online', () => notify(false));

  const original = window.fetch.bind(window);
  window.fetch = async (...args) => {
    const url = requestUrl(args[0]);
    const apiCall = isBackendApiUrl(url);

    if (apiCall && typeof navigator !== 'undefined' && navigator.onLine === false) {
      notify(true);
      const offline = new Error(INTERNET_ERROR_MESSAGE);
      offline.internetError = true;
      throw offline;
    }

    try {
      const response = await original(...args);
      if (apiCall && !response.ok) {
        response.clone().json().then((data) => {
          if (data && data.internetError) notify(true);
        }).catch(() => {});
      } else if (apiCall && response.ok) {
        notify(false);
      }
      return response;
    } catch (err) {
      // The browser could not open a connection at all. While the machine is
      // offline that is an internet error. A refused local backend stays a
      // server error so it is not mislabeled.
      if (apiCall && typeof navigator !== 'undefined' && navigator.onLine === false && isBrowserNetworkError(err)) {
        notify(true);
        const wrapped = new Error(INTERNET_ERROR_MESSAGE);
        wrapped.internetError = true;
        wrapped.cause = err;
        throw wrapped;
      }
      throw err;
    }
  };
}
